import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/Dialog';
import { Button } from '@/components/ui/Button';

interface AlertDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmText?: string;
  variant?: 'default' | 'destructive';
  icon?: React.ReactNode;
  onConfirm: () => void;
}

const AlertDialog: React.FC<AlertDialogProps> = ({
  open,
  title,
  message,
  confirmText = '확인',
  variant = 'default',
  icon,
  onConfirm,
}) => {
  return (
    <Dialog open={open}>
      <DialogContent className="sm:max-w-[425px]" onClose={onConfirm}>
        <DialogHeader>
          <DialogTitle className={icon ? "flex items-center gap-2" : ""}>
            {icon}
            {title}
          </DialogTitle>
          <DialogDescription className={icon ? "whitespace-pre-line text-base mt-2" : ""}>
            {message}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant={variant} onClick={onConfirm}>
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AlertDialog;

